import { Component } from '@angular/core';
import { AppService } from '@ui-components/services';
import { AppRoutingService } from '@ui-components/services';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrl: './complete.component.scss'
})
export class CompleteComponent {

  /** Handed over by the assessment page via navigation state (history.state survives a refresh). */
  change_innovators = !!history.state?.change_innovators;

  get login() {
    return this._app_routing_service.getAccessUrl() + 'login'
  }

  get forgotPassword() {
    return this._app_routing_service.getAccessUrl() + 'forgot-password'
  }

  constructor(
    protected _app_service: AppService,
    protected _app_routing_service: AppRoutingService
  ) {}

}
